<template>
  <div class="Comment-Reaction-Add" ref="dropdownRef">
    <button class="Comment-Reaction-Add__btn" :class="get_activeClass" @click="toggleDropdown">
      <SmileInputIcon />
    </button>
    <transition name="Anim__fadeUp">
      <div class="Comment-Reaction-Add__list" v-if="isDropdownVisible">
        <img
          class="Comment-Reaction-Add__icon"
          v-for="reaction in REACTIONS_LIST"
          :key="reaction.id"
          :src="reaction.icon"
          :alt="reaction.name"
          @click="handleReactionClick(reaction.id)"
        />
      </div>
    </transition>
  </div>
</template>

<script setup>
  import { defineProps, ref, onMounted, onUnmounted, computed } from "vue";
  import { useStore } from "vuex";
  import { Props } from './scripts/props.js';
  import { changeReaction } from '../../api/changeReaction.js'
  //------------------------------
  import SmileInputIcon from "@svg/SmileInputIcon.vue";
  //------------------------------
  const store = useStore();
  const props = defineProps(Props());
  //------------------------------
  const REACTIONS_LIST = [
    { id: 1, name: "like", icon: require("@shared/images/reactions/like.png") },
    { id: -1, name: "dislike", icon: require("@shared/images/reactions/dislike.png") },
  ];
  const COMMENTS_CTX = props.commentsPlace;
  //------------------------------
  const isDropdownVisible = ref(false);
  const dropdownRef = ref(null);
  //------------------------------
  onMounted(() => {
    document.addEventListener("click", handleClickOutside);
  });
  onUnmounted(() => {
    document.removeEventListener("click", handleClickOutside);
  });
  //------------------------------
  //Активный класс для кнопки
  const get_activeClass = computed(() => isDropdownVisible.value ? 'Comment-Reaction-Add__btn--active' : '')
  //------------------------------
  //Переключение видимости дропдауна
  const toggleDropdown = (status) => {
    isDropdownVisible.value = typeof status !== "undefined" ? status : !isDropdownVisible.value;
  };
  //Закрытие дропдауна при клике вне области
  const handleClickOutside = (event) => {
    if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
      toggleDropdown(false);
    }
  };
  //Отправляем данные на сервер
  const handleReactionClick = async (reaction) => {
    toggleDropdown(false);
    const data = {
      reaction: reaction,
      object_id: props.comment.id,
    };
    try {
      const response = await changeReaction(data);
      isDropdownVisible.value = false;
      const commentItem = store.state.ContentSystem.Comments[COMMENTS_CTX].list.find(item => item.id === props.comment.id);
      commentItem.reactions = response.reactions;
    } catch (error) {
      console.error("Ошибка обработки реакции:", error);
    }
  };
</script>

<style lang="scss">
  @import "./styles/_styles.scss";
</style>
